/* Noire Atelier — product.js */
(function () {
  'use strict';

  /* ---------- Product form (AJAX add to cart) ---------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.error = this.querySelector('[data-form-error]');
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }
    onSubmit(e) {
      e.preventDefault();
      const submitBtn = e.submitter && e.submitter.name === 'add'
        ? e.submitter
        : this.form.querySelector('[data-atc-button]') || this.form.querySelector('[type="submit"]');
      if (submitBtn && submitBtn.disabled) return;
      if (this.error) this.error.hidden = true;
      const busyTargets = [submitBtn];
      const stickyBtn = document.querySelector('[data-sticky-atc-button][form="' + this.form.id + '"]');
      if (stickyBtn) busyTargets.push(stickyBtn);
      busyTargets.forEach((b) => { if (b) { b.classList.add('is-loading'); b.setAttribute('aria-disabled', 'true'); } });
      const formData = new FormData(this.form);
      window.NoireCart.addFormData(formData)
        .then(() => {
          window.NoireUtils.announce(window.a11yStrings.itemAdded);
          if (window.themeSettings.cartType === 'drawer') {
            window.NoireCart.openDrawer();
          }
        })
        .catch((err) => {
          if (this.error) {
            this.error.hidden = false;
            this.error.textContent = (err && (err.description || err.message)) || window.a11yStrings.cartError;
          }
        })
        .finally(() => {
          busyTargets.forEach((b) => { if (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-disabled'); } });
        });
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  /* ---------- Variant selects ---------- */
  class VariantSelects extends HTMLElement {
    connectedCallback() {
      const dataScript = this.querySelector('[data-variant-json]');
      if (!dataScript) return;
      try { this.variants = JSON.parse(dataScript.textContent); } catch (err) { this.variants = []; }
      this.root = this.closest('[data-product-root]');
      this.url = this.dataset.url;
      this.sectionId = this.dataset.section;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.addEventListener('change', () => this.onChange());
      this.markAvailability();
    }
    get selectedOptions() {
      const opts = [];
      this.querySelectorAll('fieldset[data-option-index]').forEach((set) => {
        const checked = set.querySelector('input:checked');
        if (checked) opts[parseInt(set.dataset.optionIndex, 10)] = checked.value;
      });
      this.querySelectorAll('select[data-option-index]').forEach((sel) => {
        opts[parseInt(sel.dataset.optionIndex, 10)] = sel.value;
      });
      return opts;
    }
    findVariant(options) {
      return this.variants.find((v) => v.options.every((o, i) => o === options[i]));
    }
    onChange() {
      const options = this.selectedOptions;
      const variant = this.findVariant(options);
      this.markAvailability();
      const forms = this.root ? this.root.querySelectorAll('input[name="id"]') : [];
      if (!variant) {
        this.setButtonState('unavailable');
        return;
      }
      forms.forEach((input) => {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: false }));
      });
      this.setButtonState(variant.available ? 'add' : 'soldout');
      if (this.updateUrl && this.url) {
        window.history.replaceState({}, '', this.url + '?variant=' + variant.id);
      }
      this.renderSection(variant);
    }
    setButtonState(state) {
      if (!this.root) return;
      this.root.querySelectorAll('[data-atc-button]').forEach((btn) => {
        const textEl = btn.querySelector('[data-atc-text]') || btn;
        if (state === 'add') {
          btn.disabled = false;
          textEl.textContent = btn.dataset.textAdd;
        } else {
          btn.disabled = true;
          textEl.textContent = state === 'soldout' ? btn.dataset.textSoldout : btn.dataset.textUnavailable;
        }
      });
      this.mirrorSticky();
    }
    markAvailability() {
      const options = this.selectedOptions;
      this.querySelectorAll('fieldset[data-option-index]').forEach((set) => {
        const index = parseInt(set.dataset.optionIndex, 10);
        set.querySelectorAll('input[type="radio"]').forEach((input) => {
          const candidate = options.slice();
          candidate[index] = input.value;
          const match = this.findVariant(candidate);
          const unavailable = !match || !match.available;
          const wrap = input.closest('.opt-btn');
          if (wrap) wrap.classList.toggle('is-unavailable', unavailable);
        });
      });
    }
    renderSection(variant) {
      if (!this.url || !this.sectionId) return;
      let url = this.url + '?variant=' + variant.id + '&section_id=' + this.sectionId;
      const plan = this.root && this.root.querySelector('input[name="selling_plan"]:checked');
      if (plan && plan.value) url += '&selling_plan=' + plan.value;
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      fetch(url, { signal: this.controller.signal })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const activeId = document.activeElement && document.activeElement.id;
          document.querySelectorAll('[data-swap]').forEach((el) => {
            const fresh = doc.getElementById(el.id);
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
          if (activeId) {
            const restore = document.getElementById(activeId);
            if (restore && document.activeElement !== restore) restore.focus({ preventScroll: true });
          }
          const selected = doc.querySelector('[data-selected-media]');
          const gallery = this.root && this.root.querySelector('media-gallery');
          if (selected && gallery && gallery.setActiveMedia) {
            gallery.setActiveMedia(selected.getAttribute('data-selected-media'));
          }
          this.mirrorSticky();
        })
        .catch(() => {});
    }
    mirrorSticky() {
      if (!this.root) return;
      const mainBtn = this.root.querySelector('.buy-buttons [data-atc-button]');
      const stickyBtn = this.root.querySelector('[data-sticky-atc-button]');
      if (mainBtn && stickyBtn) {
        stickyBtn.disabled = mainBtn.disabled;
        const src = mainBtn.querySelector('[data-atc-text]') || mainBtn;
        const dst = stickyBtn.querySelector('[data-atc-text]') || stickyBtn;
        dst.textContent = src.textContent;
      }
    }
  }
  if (!customElements.get('variant-selects')) customElements.define('variant-selects', VariantSelects);

  /* ---------- Media gallery ---------- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('.gallery-main');
      this.slides = Array.from(this.querySelectorAll('.gallery-main .slide'));
      this.thumbs = Array.from(this.querySelectorAll('.gallery-thumbs button'));
      this.counter = this.querySelector('[data-gallery-counter]');
      this.layout = this.dataset.layout || 'stacked';
      if (!this.slides.length) return;
      this.index = 0;
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.setActiveMedia(t.dataset.mediaId, true)));
      const prev = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));
      if (this.main) {
        this.main.addEventListener('scroll', window.NoireUtils.debounce(() => this.syncFromScroll(), 100), { passive: true });
      }
      this.addEventListener('click', (e) => {
        const zoom = e.target.closest('[data-zoom]');
        if (zoom) this.openZoom(zoom.dataset.zoom, zoom.dataset.zoomAlt || '');
      });
      this.select(0, false);
    }
    setActiveMedia(mediaId, scroll) {
      const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i > -1) this.select(i, scroll !== false);
    }
    step(dir) { this.select((this.index + dir + this.slides.length) % this.slides.length, true); }
    select(i, scroll) {
      this.index = i;
      this.slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      this.thumbs.forEach((t, n) => t.setAttribute('aria-selected', n === i ? 'true' : 'false'));
      if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.slides.length;
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (scroll && this.main) {
        if (!isDesktop || this.layout === 'carousel') {
          this.main.scrollTo({ left: this.slides[i].offsetLeft, behavior: window.NoireUtils.prefersReducedMotion() ? 'auto' : 'smooth' });
        } else if (this.layout === 'stacked') {
          this.slides[i].scrollIntoView({ behavior: window.NoireUtils.prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest' });
        }
      }
    }
    syncFromScroll() {
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (isDesktop && this.layout !== 'carousel') return;
      const left = this.main.scrollLeft;
      let closest = 0;
      let min = Infinity;
      this.slides.forEach((s, n) => {
        const d = Math.abs(s.offsetLeft - left);
        if (d < min) { min = d; closest = n; }
      });
      if (closest !== this.index) this.select(closest, false);
    }
    openZoom(src, alt) {
      const modal = document.getElementById('MediaZoomModal');
      if (!modal) return;
      const target = modal.querySelector('[data-zoom-target]');
      if (target) {
        target.innerHTML = '';
        const img = document.createElement('img');
        img.src = src;
        img.alt = alt;
        target.appendChild(img);
      }
      const el = modal.matches('theme-modal') ? modal : modal.closest('theme-modal') || modal.querySelector('theme-modal');
      if (el && el.open) el.open();
    }
  }
  if (!customElements.get('media-gallery')) customElements.define('media-gallery', MediaGallery);

  /* ---------- Sticky ATC ---------- */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const targetId = this.dataset.observe;
      const target = targetId && document.getElementById(targetId);
      const bar = this.querySelector('.sticky-atc');
      if (!target || !bar || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(target);
    }
  }
  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);

  /* ---------- Quick view + quick add ---------- */
  function openQuickView(productUrl, trigger) {
    const shell = document.getElementById('QuickViewModal');
    if (!shell) { window.location.href = productUrl; return; }
    const overlay = shell.querySelector('theme-modal') || shell.closest('theme-modal');
    const target = shell.querySelector('[data-quick-view-target]');
    if (!overlay || !target) { window.location.href = productUrl; return; }
    target.innerHTML = '<div class="quick-view__loading"><span class="spinner" role="status"><span class="visually-hidden">' + window.a11yStrings.loading + '</span></span></div>';
    overlay.open(trigger);
    const sep = productUrl.includes('?') ? '&' : '?';
    fetch(productUrl + sep + 'section_id=quick-view')
      .then((r) => {
        if (!r.ok) throw new Error('load');
        return r.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('.quick-view__content');
        if (!content) throw new Error('empty');
        target.innerHTML = '';
        target.appendChild(content);
        const panel = overlay.querySelector('.modal__panel');
        if (panel) window.NoireUtils.trapFocus(panel);
      })
      .catch(() => {
        target.innerHTML = '<p><a class="link" href="' + productUrl + '">' + (target.dataset.fallbackText || 'View product') + '</a></p>';
      });
  }

  document.addEventListener('click', (e) => {
    const quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd) {
      e.preventDefault();
      const variantId = parseInt(quickAdd.dataset.variantId, 10);
      if (variantId) {
        quickAdd.classList.add('is-loading');
        window.NoireCart.addItems([{ id: variantId, quantity: 1 }])
          .then(() => {
            window.NoireUtils.announce(window.a11yStrings.itemAdded);
            window.NoireCart.openDrawer();
          })
          .catch(() => {})
          .finally(() => quickAdd.classList.remove('is-loading'));
      } else if (quickAdd.dataset.productUrl) {
        openQuickView(quickAdd.dataset.productUrl, quickAdd);
      }
      return;
    }
    const qv = e.target.closest('[data-quick-view]');
    if (qv && qv.dataset.productUrl) {
      e.preventDefault();
      openQuickView(qv.dataset.productUrl, qv);
    }
  });

  /* ---------- Gift recipient toggle ---------- */
  document.addEventListener('change', (e) => {
    const toggle = e.target.closest('[data-recipient-toggle]');
    if (!toggle) return;
    const wrap = toggle.closest('.gift-recipient') || toggle.closest('form') || document;
    const fields = wrap.querySelector('[data-recipient-fields]');
    if (fields) {
      fields.hidden = !toggle.checked;
      fields.querySelectorAll('input, textarea').forEach((f) => { f.disabled = !toggle.checked; });
      const offset = fields.querySelector('[data-recipient-offset]');
      if (offset && toggle.checked) offset.value = String(new Date().getTimezoneOffset());
    }
  });

  function initRecipientForms() {
    document.querySelectorAll('[data-recipient-toggle]').forEach((toggle) => {
      const wrap = toggle.closest('.gift-recipient') || toggle.closest('form') || document;
      const fields = wrap.querySelector('[data-recipient-fields]');
      if (!fields) return;
      fields.hidden = !toggle.checked;
      fields.querySelectorAll('input, textarea').forEach((f) => { f.disabled = !toggle.checked; });
    });
  }

  function initModelViewers() {
    if (!document.querySelector('model-viewer')) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([
      { name: 'model-viewer-ui', version: '1.0' },
      { name: 'shopify-xr', version: '1.0' }
    ], (error) => {
      if (error) return;
      document.querySelectorAll('model-viewer').forEach((mv) => {
        if (!mv.dataset.initialized && window.Shopify.ModelViewerUI) {
          new window.Shopify.ModelViewerUI(mv);
          mv.dataset.initialized = 'true';
        }
      });
    });
  }

  /* ---------- Share ---------- */
  document.addEventListener('click', (e) => {
    const share = e.target.closest('[data-share-button]');
    if (!share) return;
    e.preventDefault();
    const url = share.dataset.shareUrl || window.location.href;
    const title = share.dataset.shareTitle || document.title;
    if (navigator.share) {
      navigator.share({ url, title }).catch(() => {});
      return;
    }
    const write = navigator.clipboard && navigator.clipboard.writeText
      ? navigator.clipboard.writeText(url)
      : Promise.reject();
    write.then(() => {
      const msg = share.querySelector('[data-share-label]');
      if (msg) {
        const original = msg.textContent;
        msg.textContent = share.dataset.copiedText || original;
        window.setTimeout(() => { msg.textContent = original; }, 2000);
      }
      window.NoireUtils.announce(share.dataset.copiedText || '');
    }).catch(() => {
      window.prompt('URL', url);
    });
  });

  /* ---------- Recently viewed ---------- */
  const RV_KEY = 'noire:recent';
  function readRecent() {
    try { return JSON.parse(window.localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; }
  }
  function storeRecent() {
    const rootEl = document.querySelector('[data-product-handle]');
    if (!rootEl) return;
    const handle = rootEl.dataset.productHandle;
    if (!handle) return;
    try {
      let list = readRecent().filter((h) => h !== handle);
      list.unshift(handle);
      list = list.slice(0, 12);
      window.localStorage.setItem(RV_KEY, JSON.stringify(list));
    } catch (e) { /* storage unavailable */ }
  }

  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      const wrap = this.closest('[data-rv-wrap]');
      const grid = this.querySelector('[data-rv-grid]');
      const template = this.querySelector('template');
      if (!grid || !template) { if (wrap) wrap.hidden = true; return; }
      const exclude = this.dataset.exclude;
      const limit = parseInt(this.dataset.limit || '4', 10);
      const handles = readRecent().filter((h) => h !== exclude).slice(0, limit);
      if (!handles.length) { if (wrap) wrap.hidden = true; return; }
      Promise.all(handles.map((h) =>
        fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      )).then((products) => {
        const valid = products.filter(Boolean);
        if (!valid.length) { if (wrap) wrap.hidden = true; return; }
        valid.forEach((p) => {
          const node = template.content.cloneNode(true);
          const links = node.querySelectorAll('[data-rv-link]');
          const img = node.querySelector('[data-rv-image]');
          const title = node.querySelector('[data-rv-title]');
          const price = node.querySelector('[data-rv-price]');
          const compare = node.querySelector('[data-rv-compare]');
          links.forEach((l) => { l.href = p.url; });
          if (title) title.textContent = p.title;
          if (img) {
            if (p.featured_image) {
              const sep = p.featured_image.includes('?') ? '&' : '?';
              img.src = p.featured_image + sep + 'width=600';
              img.alt = p.title;
            } else {
              img.remove();
            }
          }
          if (price) price.textContent = window.NoireCart.formatMoney(p.price);
          if (compare) {
            if (p.compare_at_price && p.compare_at_price > p.price) {
              compare.textContent = window.NoireCart.formatMoney(p.compare_at_price);
            } else {
              compare.remove();
            }
          }
          grid.appendChild(node);
        });
      });
    }
  }
  if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);

  /* ---------- Product recommendations ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const load = () => {
        fetch(this.dataset.url)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-recommendations]');
            const wrap = this.closest('[data-recommendations-wrap]');
            if (fresh && fresh.children.length) {
              const current = this.querySelector('[data-recommendations]');
              if (current) current.innerHTML = fresh.innerHTML;
            } else if (wrap) {
              wrap.hidden = true;
            }
          })
          .catch(() => {});
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) {
            io.disconnect();
            load();
          }
        }, { rootMargin: '300px 0px' });
        io.observe(this);
      } else {
        load();
      }
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  document.addEventListener('DOMContentLoaded', () => {
    storeRecent();
    initRecipientForms();
    initModelViewers();
  });
  document.addEventListener('shopify:section:load', () => {
    initRecipientForms();
    initModelViewers();
  });
})();
